<template>
  <div class="lf-modalblocks">
    <div v-for="block in blocks" :key="block.id" class="lf-modal-wrapper__content-item">
      <div class="lf-modal-wrapper__content-item-block" @click.stop="onChooseItem(block)">
        <div :class="`lf-modal-wrapper__content-item-block-${block.image ? 'img' : 'icon'}`">
          <div :class="`lf-modal-wrapper__content-item-block-${block.image ? 'img' : 'icon'}-inner`">
            <i
              v-if="!block.image"
              :class="`icon--game ${
                block.type_id ? 'icon-game-' + stringToSlug(blockType(block?.type_id).label) : ''
              } ${!block.type_id ? 'icon-section' : ''}`"
            >
            </i>
            <img v-if="block.image" :src="block.image" :alt="block.label" />
            <span :class="`lf-modal-wrapper__content-item-block-${block.image ? 'img' : 'icon'}-text`">
              {{ block.label }}
            </span>
          </div>
        </div>
        <div class="lf-modal-wrapper__content-item-block-text">
          <button type="button" class="btn btn-light">
            <i
              :class="{
                'icon-plus': determineShowIcon !== 'copy',
                'icon-arrow-toggle': determineShowIcon === 'copy'
              }"
            ></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { stringToSlug } from '@/utilities/Utilities';
import { APIBlock, APICategory } from '@/components/components/editing/Modals/interfaces';
import { BlockTypes } from '@/typings/types/types';

interface EmptyColumn {
  size: number;
  addons: [];
}

const BLOCKID_CONFIG = {
  TEMPLATE: 'template',
  GLOBAL: 'global',
  GRID: 'grid',
  COPY_PAGE: 'copy-page'
};

export default defineComponent({
  name: 'ModalBlocks',
  props: {
    blocks: {
      type: Array as PropType<APIBlock[]>,
      required: true
    },
    categories: {
      type: Array as PropType<APICategory[]>,
      required: true
    },
    determineShowIcon: {
      type: String,
      required: true
    },
    type: {
      type: String as PropType<BlockTypes>,
      required: true
    }
  },
  emits: ['addItem', 'navigateToFlowPages', 'navigateToSections'],
  setup(props, context) {
    const onChooseItem = (block: APIBlock) => {
      const gridId = block.id.toString();
      if (props.type === 'blocks') {
        const columns = gridId
          .replace('grid-', '')
          .split('x')
          .map<EmptyColumn>((column) => {
            return {
              size: parseInt(column, 10),
              addons: []
            };
          });
        context.emit('addItem', columns);
      } else if (props.type === 'pages-flow' || props.type === 'pages-page') {
        if (
          gridId.includes(BLOCKID_CONFIG.COPY_PAGE) ||
          gridId.includes(BLOCKID_CONFIG.GRID) ||
          (props.type === 'pages-flow' && gridId.includes(BLOCKID_CONFIG.TEMPLATE)) ||
          (props.type === 'pages-flow' && gridId.includes(BLOCKID_CONFIG.GLOBAL)) ||
          (props.type === 'pages-page' && gridId.includes(BLOCKID_CONFIG.TEMPLATE)) ||
          (props.type === 'pages-page' && gridId.includes(BLOCKID_CONFIG.GLOBAL))
        ) {
          context.emit('addItem', block);
        } else if (
          (props.type === 'pages-flow' && block.id.toString().includes('template')) ||
          (props.type === 'pages-flow' && block.id.toString().includes('global')) ||
          (props.type === 'pages-page' && block.id.toString().includes('template')) ||
          (props.type === 'pages-page' && block.id.toString().includes('global'))
        ) {
          context.emit('addItem', block);
        } else {
          /** If reusing flowpages, navigate to flowpages */
          context.emit('navigateToFlowPages', block.id);
        }
      } else if (props.type === 'sections' && !isNaN(Number(gridId))) {
        /** If reusing sections, navigate to sections, first step will always return a number as a gridId */
        context.emit('navigateToSections', gridId);
      } else {
        context.emit('addItem', block);
      }
    };

    const blockType = (typeId: string): APICategory => {
      const blockType = (props.categories as APICategory[]).find((category) => {
        return category.id == typeId;
      });

      if (!blockType) {
        throw new Error(`Unknown block type "${typeId}"`);
      }

      return blockType;
    };

    return {
      stringToSlug,
      blockType,
      onChooseItem
    };
  }
});
</script>

<style lang="scss" scoped>
.lf-modal-wrapper__content-item-block-img-text {
  display: none;
}
</style>
